import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from "react";
import { Flex, SubText } from "@base-ui";
import { useNotificationContext } from "@notifications/context";
import { useCustomEffect } from "hooks";
import { NotificationHolder, Icon, Close } from "./notificationBanner.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NotificationBanner(props) {
  var _useNotificationConte = useNotificationContext(),
    showNotification = _useNotificationConte.showNotification,
    notification = _useNotificationConte.notification,
    hideNotification = _useNotificationConte.hideNotification;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    contentToShow = _useState2[0],
    setContentToShow = _useState2[1];
  var close = function close() {
    hideNotification();
    setContentToShow(null);
  };
  var initializeNotificationBanner = function initializeNotificationBanner(message, warningLevel) {
    if (!message) return;
    var icon = warningLevel === "alert" ? "alert" : warningLevel === "error" ? "error" : warningLevel === "warning" ? "warning" : "";
    setContentToShow( /*#__PURE__*/_jsxs(NotificationHolder, {
      className: "NotificationHolder",
      children: [/*#__PURE__*/_jsx(Icon, {
        icon: icon
      }), /*#__PURE__*/_jsx(SubText, {
        role: "alert",
        children: message
      }), /*#__PURE__*/_jsx(Close, {
        onClick: function onClick() {
          return close();
        }
      })]
    }));
  };
  useCustomEffect(function () {
    if (showNotification) initializeNotificationBanner(notification === null || notification === void 0 ? void 0 : notification.text, "alert");else setContentToShow(null);
  }, [showNotification]);
  return showNotification && /*#__PURE__*/_jsx(Flex.Row, {
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      zIndex: "99",
      position: "sticky",
      top: 0
    }),
    children: contentToShow
  });
}